<template>
  <v-container>
    <div class="container-style">
      <div style="width: 100%; text-align: center">
        <img src="../assets/NotFound.png" />
        <p class="text"><strong>ບໍ່ພົບໜ້ານີ້</strong></p>
        <v-btn href="/" outlined color="error"
          >ກັບຄືນສູ່ໜ້າຫຼັກ></v-btn
        >
      </div>
    </div>
    <div></div>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
img {
  width: 20%;
  user-drag: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
}
.text {
  font-size: 35px;
}
@media only screen and (max-width: 600px) {
  .text {
    font-size: 20px;
  }
}
.container-style {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
}
</style>
